<template>
  <div class="login-additional-action">
    <router-link
      v-if="asLink"
      :to="urlPath"
      class="login-additional-button"
    >
      {{label}}
      <v-icon>chevron_right</v-icon>
    </router-link>
    <button v-else class="login-additional-button">
      {{label}}
      <v-icon>chevron_right</v-icon>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      required: true
    },
    asLink: {
      type: Boolean,
      default: false
    },
    urlPath: {
      type: Object,
      default: () => {}
    }
  },
}
</script>

<style lang="scss" scoped>
.login-additional-action {
  margin-top: 40px;
  border-top: 1px solid #D3D3D3;
  border-bottom: 1px solid #D3D3D3;
  color: var(--secondary-text-color, #818181);

  & + & {
    margin-top: 0;
    border-top: none;
  }
}

.login-additional-button {
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding: 15px 0;
  color: inherit;

  i {
    position: relative;
    left: 6px;
    color: var(--secondary-text-color, #818181);
  }
}
</style>
